<template>
  <section class="flex w-full items-center justify-center text-black">
    <div class="container mx-auto flex flex-col items-center justify-center px-5 py-24">
      <div class="w-full text-center lg:w-2/3">
        <h1 class="title-font mb-4 text-3xl font-medium text-brand-600 sm:text-4xl">
          {{ $route.name }}
        </h1>
      </div>
    </div>
  </section>
</template>
